<template>
  <div class="home-layout">
    <Navbar />

    <main class="home-main">
      <HeroCarousel />
      <AboutSection />
      <VideoSection />
      <ServicesSection />
      <TravelInsurance />
      <PartnersSection />
    </main>

    <a
      href="https://wa.me/529993775400"
      class="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/5/5e/WhatsApp_icon.png"
        alt=""
        class="whatsapp-icon"
      />
    </a>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import HeroCarousel from "@/components/HeroCarousel.vue";
import AboutSection from "@/components/AboutSection.vue";
import VideoSection from "@/components/VideoSection.vue";
import ServicesSection from "@/components/ServicesSection.vue";
import TravelInsurance from "@/components/TravelInsurance.vue";
import PartnersSection from "@/components/PartnersSection.vue";

export default {
  name: "HomeLayout",

  components: {
    Navbar,
    HeroCarousel,
    AboutSection,
    VideoSection,
    ServicesSection,
    TravelInsurance,
    PartnersSection,
  },

  data() {
    return {
      tiempoInicio: 0,
    };
  },

  mounted() {
    this.tiempoInicio = Date.now();
    window.addEventListener("pagehide", this.registrarTiempoEstadia);
  },

  beforeUnmount() {
    window.removeEventListener("pagehide", this.registrarTiempoEstadia);
  },

  methods: {
    registrarTiempoEstadia() {
      const segundos = Math.max(
        1,
        Math.round((Date.now() - this.tiempoInicio) / 1000)
      );

      const datos = JSON.stringify({
        tiempo_estadia: segundos,
      });

      const blob = new Blob([datos], {
        type: "application/json",
      });

      navigator.sendBeacon(
        "http://localhost:3000/api/visitas/registrar-visita",
        blob
      );
    },
  },
};
</script>

<style>
.home-layout {
  width: 100%;
  min-height: 100vh;
  overflow-x: clip;
  background: #ffffff;
}

.home-main {
  width: 100%;
}

.whatsapp-float {
  position: fixed;
  right: max(20px, env(safe-area-inset-right));
  bottom: max(20px, env(safe-area-inset-bottom));
  z-index: 1000;
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: #25d366;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.2);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.whatsapp-float:hover {
  transform: translateY(-3px) scale(1.04);
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.24);
}

.whatsapp-float:focus-visible {
  outline: 3px solid rgba(37, 211, 102, 0.35);
  outline-offset: 4px;
}

.whatsapp-icon {
  width: 34px;
  height: 34px;
  display: block;
}

@media (max-width: 768px) {
  .whatsapp-float {
    right: max(14px, env(safe-area-inset-right));
    bottom: max(14px, env(safe-area-inset-bottom));
    width: 52px;
    height: 52px;
  }

  .whatsapp-icon {
    width: 30px;
    height: 30px;
  }
}

@media (max-width: 480px) {
  .whatsapp-float {
    width: 48px;
    height: 48px;
  }

  .whatsapp-icon {
    width: 28px;
    height: 28px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .whatsapp-float {
    transition: none;
  }
}
</style>
